import module from '@kendu/ui/module'
import './style.scss'

class kdDialogActionsComponent {
}

module.component('kdDialogActions', {
  controller: kdDialogActionsComponent,
})



// WEBPACK FOOTER //
// ./src/kendu/ui/components/kd-dialog-actions/component.js